import { createTracker } from 'usage-tracker';
import events from '../../events.yaml';
import { ADD_SUBMISSION_NOTE, ANALYZE, ANALYZE_INTERACTION, CANCEL_DELETE_SUBMISSION, CANCEL_ONBOARDING, CANCEL_UI_TOUR, CLICK_ANALYZE_KB_LINK, CLICK_ANALYZE_OPT_IN, CLICK_ANALYZE_OPT_IN_CONFIRM, CLICK_DELETE_SUBMISSION, CLICK_SUBMIT_FORECAST_FROM_DEAL_TABLE, CLOSE_SUBMISSION_PANEL, CONFIRM_DELETE_OTHER_SUBMISSION, CONFIRM_DELETE_OWN_SUBMISSION, CREATE_FORECAST_WIZARD, CREATE_GOAL_IN_APP, DEAL_TABLE_EDIT_COLUMNS_OPEN, DEAL_TABLE_EDIT_COLUMNS_SAVE, DEAL_TABLE_SORT, DESELECT_DEAL_FROM_DEAL_TABLE, DISMISS_AI_FORECASTING_V2_ALERT, DISMISS_SET_CURRENCY_ALERT, DRILL_INTO_TEAM, EDIT_GOALS_FROM_FORECAST, FINISH_ONBOARDING, FINISH_UI_TOUR, FORECAST_TYPE_PERMISSION_ERROR, FORECASTING_INTERACTION, INLINE_EDIT_DEAL_PROPERTY, MANAGE_FORECASTS, NAVIGATE_BACK_IN_SUBMISSION_HISTORY, NAVIGATE_BY_BREADCRUMB, NAVIGATE_FORWARD_IN_SUBMISSION_HISTORY, NAVIGATE_TO_SALES_ANALYTICS, NEXT_STEP_ONBOARDING, NEXT_STEP_UI_TOUR, OPEN_DEAL_FROM_INCLUDED_DEALS, OPEN_DEAL_SIDEBAR, OPEN_DEAL_SIDEBAR_FROM_DEAL_COUNT, OPEN_EDIT_DEFAULT_COLUMNS, OPEN_GOALS_FROM_ATTAINMENT, OPEN_GOALS_SIDEBAR_FROM_ATTAINMENT, OPEN_MULTICURRENCY_PANEL, OPEN_REP_DETAIL_FROM_SUBMISSION_PANEL, OPEN_SUBMISSION_PANEL, OPEN_SUBMISSION_PANEL_BY_SELECTING_DEAL, OVERRIDE_SELECTED_DEAL_AMOUNT, PREVIEW_DEAL, PREVIOUS_STEP_ONBOARDING, REASSIGN_DEALS_FOR_DEACTIVATED_USER, REP_DETAIL, REP_OVERVIEW, SAVE_BAR_CANCEL, SELECT_DEAL_FROM_DEAL_TABLE, SET_ANALYZE_PIPELINE, SET_PREFERRED_CURRENCY, SHOW_DEAL_STAGE_FORECAST_INTRO_MODAL, SHOW_DEALS_NOT_SAVED_ALERT, START_ONBOARDING, START_UI_TOUR, SUBMIT_FORECAST, SUBMIT_FORECAST_FOR_ALL_PIPELINES, SWITCH_FORECAST_TYPE, SWITCH_FORECAST_TYPES, SWITCH_TABS, SWITCH_TO_DEALS_SIDEBAR, SWITCH_TO_GOALS_SIDEBAR, VIEW_CURRENCIES_FROM_PANEL, VIEW_DEALS_IN_CRM_FROM_SIDEBAR, VIEW_FORECAST_USERS_POPOVER, VIEW_GOALS_IN_CRM_FROM_SIDEBAR, VIEW_INCLUDED_DEALS_FROM_HISTORY, VIEW_INCLUDED_DEALS_FROM_SUBMIT, VIEW_REPORT_FROM_FORECAST, VIEW_SUBMISSION_PANEL_HISTORY, WIZARD } from '../constants/Events';
import { enhanceTrackerWithFullstory } from 'data-ops-fullstory';
import { MSG_TYPE_CANCEL_DELETE_SUBMISSION, MSG_TYPE_CONFIRM_DELETE_OWN_SUBMISSION, MSG_TYPE_CONFIRM_DELETE_OTHER_SUBMISSION, MSG_TYPE_SHOW_DELETE_SUBMISSION_MODAL, MSG_TYPE_SUBMIT_SUCCESS, MSG_TYPE_SUBMIT_SUCCESS_ALL_PIPELINES, MSG_TYPE_TRACK_ADD_SUBMISSION_NOTE, MSG_TYPE_TRACK_NAVIGATE_TO_SALES_ANALYTICS, MSG_TYPE_TRACK_OPEN_SUBMISSION_PANEL, MSG_TYPE_TRACK_OVERRIDE_SELECTED_DEAL_AMOUNT, MSG_TYPE_TRACK_VIEW_HISTORY_TAB, MSG_TYPE_TRACK_NAVIGATE_BACK_IN_SUBMISSION_HISTORY, MSG_TYPE_TRACK_NAVIGATE_FORWARD_IN_SUBMISSION_HISTORY, MSG_TYPE_TRACK_CLOSE_SUBMISSION_PANEL, MSG_TYPE_TRACK_NAVIGATE_TO_REP_DETAIL, MSG_TYPE_TRACK_VIEW_INCLUDED_DEALS_FROM_SUBMIT, MSG_TYPE_TRACK_VIEW_INCLUDED_DEALS_FROM_HISTORY, MSG_TYPE_TRACK_OPEN_DEAL_FROM_INCLUDED_DEALS, MSG_TYPE_SHOW_DEALS_NOT_SAVED_ALERT } from 'ui-deal-management-components-lib/constants/messages';
export const tracker = enhanceTrackerWithFullstory(createTracker({
  events
}));
export const trackPreviewDeal = isDealStageView => {
  tracker.track(FORECASTING_INTERACTION, {
    screen: REP_DETAIL,
    action: PREVIEW_DEAL,
    isDealStageView
  });
};
export const trackRepDetailView = ({
  hasData,
  isDealStageView,
  isDefaultForecast,
  pipeline,
  timePeriod,
  cadence,
  cadenceMatchesTimePeriod
}) => {
  tracker.track('pageView', {
    screen: REP_DETAIL,
    hasData,
    isDealStageView,
    isDefaultForecast,
    pipeline,
    timePeriod,
    cadence,
    cadenceMatchesTimePeriod
  });
};
export const trackOverviewView = ({
  companyCurrency,
  isDealStageView,
  ownersInTable,
  ownersNotAssignedTeams,
  preferredCurrency,
  quotasForOwners,
  isDefaultForecast
}) => {
  const isCompanyCurrency = !preferredCurrency || preferredCurrency === companyCurrency;
  tracker.track('pageView', {
    isCompanyCurrency,
    isDealStageView,
    ownersInTable,
    ownersNotAssignedTeams,
    quotasForOwners,
    screen: REP_OVERVIEW,
    subscreen: 'table',
    isDefaultForecast
  });
};

// NOTE: for FDT, this is effectively the save-bar-save event, with the
// corresponding SAVE_BAR_CANCEL event below
export const trackInlineEditDealProperty = (isDealStageView, propertyKeys) => {
  tracker.track(FORECASTING_INTERACTION, {
    screen: REP_DETAIL,
    action: INLINE_EDIT_DEAL_PROPERTY,
    isDealStageView,
    propertyKeys
  });
};
export const trackDrillIntoTeamView = isDealStageView => tracker.track(FORECASTING_INTERACTION, {
  screen: REP_OVERVIEW,
  action: DRILL_INTO_TEAM,
  isDealStageView
});
export const trackNavigateByBreadcrumb = isDealStageView => tracker.track(FORECASTING_INTERACTION, {
  screen: REP_OVERVIEW,
  action: NAVIGATE_BY_BREADCRUMB,
  isDealStageView
});
export const trackOpenGoalsFromAttainment = ({
  isDealStageView,
  isDetail,
  subscreen,
  team
}) => {
  tracker.track(FORECASTING_INTERACTION, {
    screen: isDetail ? REP_DETAIL : REP_OVERVIEW,
    subscreen,
    action: OPEN_GOALS_FROM_ATTAINMENT,
    isDealStageView,
    teamId: team
  });
};
export const trackSelectDealFromDealTable = isDealStageView => tracker.track(FORECASTING_INTERACTION, {
  screen: REP_DETAIL,
  action: SELECT_DEAL_FROM_DEAL_TABLE,
  isDealStageView
});
export const trackDeselectDealFromDealTable = isDealStageView => tracker.track(FORECASTING_INTERACTION, {
  screen: REP_DETAIL,
  action: DESELECT_DEAL_FROM_DEAL_TABLE,
  isDealStageView
});
export const trackOpenSubmissionPanelBySelectingDeal = isDealStageView => tracker.track(FORECASTING_INTERACTION, {
  screen: REP_DETAIL,
  action: OPEN_SUBMISSION_PANEL_BY_SELECTING_DEAL,
  isDealStageView
});
export const trackClickSubmitForecastFromDealTable = isDealStageView => tracker.track(FORECASTING_INTERACTION, {
  screen: REP_DETAIL,
  action: CLICK_SUBMIT_FORECAST_FROM_DEAL_TABLE,
  isDealStageView
});
export const trackWizardStart = () => tracker.track(FORECASTING_INTERACTION, {
  screen: WIZARD,
  action: START_ONBOARDING
});
export const trackWizardInteraction = (subscreen, action) => tracker.track(FORECASTING_INTERACTION, {
  screen: WIZARD,
  action,
  subscreen
});
export const trackWizardNextStep = subscreen => tracker.track(FORECASTING_INTERACTION, {
  screen: WIZARD,
  action: NEXT_STEP_ONBOARDING,
  subscreen
});
export const trackWizardPrevStep = subscreen => tracker.track(FORECASTING_INTERACTION, {
  screen: WIZARD,
  action: PREVIOUS_STEP_ONBOARDING,
  subscreen
});
export const trackWizardCancel = subscreen => tracker.track(FORECASTING_INTERACTION, {
  screen: WIZARD,
  action: CANCEL_ONBOARDING,
  subscreen
});
export const trackWizardFinish = subscreen => tracker.track(FORECASTING_INTERACTION, {
  screen: WIZARD,
  action: FINISH_ONBOARDING,
  subscreen
});
export const trackOverviewSearch = (isDealStageView, action) => tracker.track(FORECASTING_INTERACTION, {
  screen: REP_OVERVIEW,
  action,
  isDealStageView
});
export const trackSwitchForecastTypes = (isDetail, tab) => tracker.track(FORECASTING_INTERACTION, {
  screen: isDetail ? REP_DETAIL : REP_OVERVIEW,
  action: SWITCH_FORECAST_TYPES,
  tab
});
export const trackSwitchTab = (isDetail, tab) => tracker.track(FORECASTING_INTERACTION, {
  screen: isDetail ? REP_DETAIL : REP_OVERVIEW,
  action: SWITCH_TABS,
  tab
});
export const trackSaveBarCancel = isDealStageView => tracker.track(FORECASTING_INTERACTION, {
  screen: REP_DETAIL,
  action: SAVE_BAR_CANCEL,
  isDealStageView
});
export const trackDealTableSort = isDealStageView => tracker.track(FORECASTING_INTERACTION, {
  screen: REP_DETAIL,
  action: DEAL_TABLE_SORT,
  isDealStageView
});
export const trackDealTableEditColumnsOpen = isDealStageView => tracker.track(FORECASTING_INTERACTION, {
  screen: REP_DETAIL,
  action: DEAL_TABLE_EDIT_COLUMNS_OPEN,
  isDealStageView
});
export const trackDealTableEditColumnsSave = isDealStageView => tracker.track(FORECASTING_INTERACTION, {
  screen: REP_DETAIL,
  action: DEAL_TABLE_EDIT_COLUMNS_SAVE,
  isDealStageView
});
export const trackOpenDealSidebar = isDealStageView => tracker.track(FORECASTING_INTERACTION, {
  screen: REP_OVERVIEW,
  action: OPEN_DEAL_SIDEBAR,
  isDealStageView
});
export const trackViewDealsInCrmFromSidebar = isDealStageView => tracker.track(FORECASTING_INTERACTION, {
  screen: REP_OVERVIEW,
  action: VIEW_DEALS_IN_CRM_FROM_SIDEBAR,
  isDealStageView
});
export const trackViewGoalsInCrmFromSidebar = isDealStageView => tracker.track(FORECASTING_INTERACTION, {
  screen: REP_OVERVIEW,
  action: VIEW_GOALS_IN_CRM_FROM_SIDEBAR,
  isDealStageView
});
export const trackCreateInAppGoal = ({
  isDealStageView,
  isDefaultForecast
}) => tracker.track(FORECASTING_INTERACTION, {
  screen: REP_OVERVIEW,
  action: CREATE_GOAL_IN_APP,
  isDealStageView,
  isDefaultForecast
});
export const trackReassignDealsForDeactivatedUser = (isDetail, isDealStageView) => tracker.track(FORECASTING_INTERACTION, {
  screen: isDetail ? REP_DETAIL : REP_OVERVIEW,
  action: REASSIGN_DEALS_FOR_DEACTIVATED_USER,
  isDealStageView
});
export const createOnTrackHandlerForSubmissionPanel = ({
  companyCurrency,
  currencyCode,
  isDealStageView,
  isDetailPage,
  submissionPanelData,
  isDefaultForecast,
  selectedDealCount
}) => interaction => {
  const {
    id,
    isUser
  } = submissionPanelData || {};
  const isCompanyCurrency = currencyCode ? currencyCode === companyCurrency : null;
  let action = '';
  switch (interaction) {
    case MSG_TYPE_SUBMIT_SUCCESS:
      action = SUBMIT_FORECAST;
      break;
    case MSG_TYPE_SUBMIT_SUCCESS_ALL_PIPELINES:
      action = SUBMIT_FORECAST_FOR_ALL_PIPELINES;
      break;
    case MSG_TYPE_TRACK_OVERRIDE_SELECTED_DEAL_AMOUNT:
      action = OVERRIDE_SELECTED_DEAL_AMOUNT;
      break;
    case MSG_TYPE_TRACK_ADD_SUBMISSION_NOTE:
      action = ADD_SUBMISSION_NOTE;
      break;
    case MSG_TYPE_TRACK_VIEW_HISTORY_TAB:
      action = VIEW_SUBMISSION_PANEL_HISTORY;
      break;
    case MSG_TYPE_TRACK_NAVIGATE_TO_SALES_ANALYTICS:
      action = NAVIGATE_TO_SALES_ANALYTICS;
      break;
    case MSG_TYPE_TRACK_OPEN_SUBMISSION_PANEL:
      action = OPEN_SUBMISSION_PANEL;
      break;
    case MSG_TYPE_TRACK_NAVIGATE_BACK_IN_SUBMISSION_HISTORY:
      action = NAVIGATE_BACK_IN_SUBMISSION_HISTORY;
      break;
    case MSG_TYPE_TRACK_NAVIGATE_FORWARD_IN_SUBMISSION_HISTORY:
      action = NAVIGATE_FORWARD_IN_SUBMISSION_HISTORY;
      break;
    case MSG_TYPE_TRACK_CLOSE_SUBMISSION_PANEL:
      action = CLOSE_SUBMISSION_PANEL;
      break;
    case MSG_TYPE_TRACK_NAVIGATE_TO_REP_DETAIL:
      action = OPEN_REP_DETAIL_FROM_SUBMISSION_PANEL;
      break;
    case MSG_TYPE_TRACK_VIEW_INCLUDED_DEALS_FROM_SUBMIT:
      action = VIEW_INCLUDED_DEALS_FROM_SUBMIT;
      break;
    case MSG_TYPE_TRACK_VIEW_INCLUDED_DEALS_FROM_HISTORY:
      action = VIEW_INCLUDED_DEALS_FROM_HISTORY;
      break;
    case MSG_TYPE_TRACK_OPEN_DEAL_FROM_INCLUDED_DEALS:
      action = OPEN_DEAL_FROM_INCLUDED_DEALS;
      break;
    case MSG_TYPE_SHOW_DELETE_SUBMISSION_MODAL:
      action = CLICK_DELETE_SUBMISSION;
      break;
    case MSG_TYPE_CONFIRM_DELETE_OWN_SUBMISSION:
      action = CONFIRM_DELETE_OWN_SUBMISSION;
      break;
    case MSG_TYPE_CONFIRM_DELETE_OTHER_SUBMISSION:
      action = CONFIRM_DELETE_OTHER_SUBMISSION;
      break;
    case MSG_TYPE_CANCEL_DELETE_SUBMISSION:
      action = CANCEL_DELETE_SUBMISSION;
      break;
    case MSG_TYPE_SHOW_DEALS_NOT_SAVED_ALERT:
      action = SHOW_DEALS_NOT_SAVED_ALERT;
      break;
    default:
      // Defaulting action = interaction provides us with the most context if LogFetch Errors catches an action that is not part of events.yaml
      action = interaction;
      break;
  }
  tracker.track(FORECASTING_INTERACTION, {
    screen: isDetailPage ? REP_DETAIL : REP_OVERVIEW,
    action,
    currencyCode,
    isCompanyCurrency,
    isDealStageView,
    teamId: isUser ? null : id,
    isDefaultForecast,
    selectedDealCount
  });
};
export const trackTourClick = action => {
  tracker.track(FORECASTING_INTERACTION, {
    screen: REP_OVERVIEW,
    action
  });
};
export const trackCreateForecastClick = action => {
  tracker.track(FORECASTING_INTERACTION, {
    screen: REP_OVERVIEW,
    action
  });
};
export const trackSwitchForecastType = ({
  screen,
  isDealStageView,
  isDefaultForecastBefore,
  isDefaultForecastAfter
}) => {
  tracker.track(FORECASTING_INTERACTION, {
    screen,
    action: SWITCH_FORECAST_TYPE,
    isDealStageView,
    isDefaultForecastBefore,
    isDefaultForecast: isDefaultForecastAfter
  });
};
export const trackShowForecastTypePermissionError = isDetail => {
  tracker.track(FORECASTING_INTERACTION, {
    screen: isDetail ? REP_DETAIL : REP_OVERVIEW,
    action: FORECAST_TYPE_PERMISSION_ERROR
  });
};
export const trackForecastTypeWizard = (type, additionalContext) => {
  tracker.track(FORECASTING_INTERACTION, Object.assign({
    screen: CREATE_FORECAST_WIZARD,
    action: type
  }, additionalContext));
};
export const trackStartUITour = (screen, isDealStageView) => tracker.track(FORECASTING_INTERACTION, {
  screen,
  action: START_UI_TOUR,
  isDealStageView
});
export const trackNextStepUITour = (currentStep, screen, isDealStageView) => tracker.track(FORECASTING_INTERACTION, {
  screen,
  action: NEXT_STEP_UI_TOUR,
  currentStep,
  isDealStageView
});
export const trackCancelUITour = (currentStep, screen, isDealStageView) => tracker.track(FORECASTING_INTERACTION, {
  screen,
  action: CANCEL_UI_TOUR,
  currentStep,
  isDealStageView
});
export const trackFinishUITour = (currentStep, screen, isDealStageView) => tracker.track(FORECASTING_INTERACTION, {
  screen,
  action: FINISH_UI_TOUR,
  currentStep,
  isDealStageView
});
export const trackShowOnboardingIntroModal = () => tracker.track(FORECASTING_INTERACTION, {
  screen: REP_OVERVIEW,
  action: SHOW_DEAL_STAGE_FORECAST_INTRO_MODAL,
  isDealStageView: true
});
export const trackViewAnalyzeTab = ({
  subscreen
} = {
  subscreen: undefined
}) => tracker.track('pageView', {
  screen: ANALYZE,
  subscreen
});
export const trackSetAnalyzePipeline = pipeline => tracker.track(ANALYZE_INTERACTION, {
  action: SET_ANALYZE_PIPELINE,
  pipeline
});
export const trackClickKBLink = ({
  subscreen
}) => tracker.track(ANALYZE_INTERACTION, {
  action: CLICK_ANALYZE_KB_LINK,
  subscreen
});
export const trackClickAnalyzeOptIn = () => tracker.track(ANALYZE_INTERACTION, {
  action: CLICK_ANALYZE_OPT_IN
});
export const trackClickAnalyzeOptInConfirm = () => {
  tracker.track(ANALYZE_INTERACTION, {
    action: CLICK_ANALYZE_OPT_IN_CONFIRM
  });
};
export const trackOpenMulticurrencyPanel = ({
  isDealStageView,
  isDetail
}) => {
  tracker.track(FORECASTING_INTERACTION, {
    action: OPEN_MULTICURRENCY_PANEL,
    isDealStageView,
    screen: isDetail ? REP_DETAIL : REP_OVERVIEW
  });
};
export const trackSetPreferredCurrency = ({
  companyCurrency,
  currencyCode,
  isDealStageView,
  isDetail
}) => {
  tracker.track(FORECASTING_INTERACTION, {
    action: SET_PREFERRED_CURRENCY,
    isCompanyCurrency: currencyCode === companyCurrency,
    isDealStageView,
    currencyCode,
    screen: isDetail ? REP_DETAIL : REP_OVERVIEW
  });
};
export const trackViewCurrenciesFromPanel = ({
  isDealStageView,
  isDetail
}) => {
  tracker.track(FORECASTING_INTERACTION, {
    action: VIEW_CURRENCIES_FROM_PANEL,
    isDealStageView,
    screen: isDetail ? REP_DETAIL : REP_OVERVIEW
  });
};
export const trackOpenGoalsSidebarFromAttainment = ({
  isDealStageView,
  isDetail
}) => {
  tracker.track(FORECASTING_INTERACTION, {
    action: OPEN_GOALS_SIDEBAR_FROM_ATTAINMENT,
    isDealStageView,
    screen: isDetail ? REP_DETAIL : REP_OVERVIEW
  });
};
export const trackSwitchToGoalsSidebar = ({
  isDealStageView
}) => {
  tracker.track(FORECASTING_INTERACTION, {
    action: SWITCH_TO_GOALS_SIDEBAR,
    isDealStageView,
    screen: REP_OVERVIEW
  });
};
export const trackSwitchToDealsSidebar = ({
  isDealStageView
}) => {
  tracker.track(FORECASTING_INTERACTION, {
    action: SWITCH_TO_DEALS_SIDEBAR,
    isDealStageView,
    screen: REP_OVERVIEW
  });
};
export const trackOpenDealSidebarFromDealCount = ({
  isDealStageView,
  isDetail
}) => {
  tracker.track(FORECASTING_INTERACTION, {
    action: OPEN_DEAL_SIDEBAR_FROM_DEAL_COUNT,
    isDealStageView,
    screen: isDetail ? REP_DETAIL : REP_OVERVIEW
  });
};
export const trackViewForecastUsersPopover = ({
  isDealStageView,
  isDetail
}) => {
  tracker.track(FORECASTING_INTERACTION, {
    action: VIEW_FORECAST_USERS_POPOVER,
    isDealStageView,
    screen: isDetail ? REP_DETAIL : REP_OVERVIEW
  });
};
export const trackEditGoalsFromForecast = ({
  isDealStageView,
  isDetail
}) => {
  tracker.track(FORECASTING_INTERACTION, {
    action: EDIT_GOALS_FROM_FORECAST,
    isDealStageView,
    screen: isDetail ? REP_DETAIL : REP_OVERVIEW
  });
};
export const trackViewReportFromForecast = ({
  isDealStageView,
  isDetail
}) => {
  tracker.track(FORECASTING_INTERACTION, {
    action: VIEW_REPORT_FROM_FORECAST,
    isDealStageView,
    screen: isDetail ? REP_DETAIL : REP_OVERVIEW
  });
};
export const trackDismissSetCurrencyAlert = isDetail => {
  tracker.track(FORECASTING_INTERACTION, {
    action: DISMISS_SET_CURRENCY_ALERT,
    screen: isDetail ? REP_DETAIL : REP_OVERVIEW
  });
};
export const trackDismissAIForecastingV2Alert = () => {
  tracker.track(FORECASTING_INTERACTION, {
    action: DISMISS_AI_FORECASTING_V2_ALERT,
    screen: ANALYZE
  });
};
export const trackOpenManageTabFromForecast = ({
  isDealStageView,
  isDetail
}) => {
  tracker.track(FORECASTING_INTERACTION, {
    action: MANAGE_FORECASTS,
    isDealStageView,
    screen: isDetail ? REP_DETAIL : REP_OVERVIEW
  });
};
export const trackClickEditDefaultColumnsLink = () => {
  tracker.track(FORECASTING_INTERACTION, {
    action: OPEN_EDIT_DEFAULT_COLUMNS,
    screen: REP_OVERVIEW
  });
};